export default __webpack_public_path__ + "static/media/skole.f8ff9eb2.JPG";